export default __webpack_public_path__ + "static/sandy2-1bdf77da5be5f671806fec5f984ece18.webp";